import { TablaRecibos } from "../components";

/**
 * Endoso 25 (HU6, iteración 2): pantalla de refacturación mostrada tras
 * confirmar el endoso, cuando el usuario elige "Refacturar" en el modal
 * "¿requiere refacturar?". Al confirmar la refacturación el flujo salta
 * directo a la carátula del endoso, sin pantalla intermedia de resultados.
 */
export const Refacturacion25 = () => <TablaRecibos />;
